import {useEffect, useState} from 'react';
import CategoryDefaultTemplate from '@/components/main/MyPlus/common/TemplateType/CategoryDefaultTemplate';
import useMainStore from '@/stores/main';
import {CATEGORY_SLICE_CNT} from '@/constants/main';
import '/public/static/css/module/category.scss';

const CategoryContentType = ({
  data,
  selectedMode,
  useSlider,
  rowCount,
  onChangeEnabled,
}) => {
  const {resizeCategoryCount} = useMainStore();

  const [itemList, setItemList] = useState([]);
  const [displayedContent, setDisplayedContent] = useState([]);

  useEffect(() => {
    if (data) {
      setItemList([...data]);

      if (data.length < 10) {
        onChangeEnabled(false);
      } else {
        onChangeEnabled(true);
      }
    }
  }, [data]);

  useEffect(() => {
    if (useSlider) {
      setDisplayedContent([...itemList.slice(0, CATEGORY_SLICE_CNT)]);
    } else {
      const visibleListCount = resizeCategoryCount * rowCount;
      setDisplayedContent([...itemList.slice(0, visibleListCount)]);
    }
  }, [itemList, resizeCategoryCount, useSlider, rowCount]);

  return (
    <>
      <CategoryDefaultTemplate
        itemList={displayedContent}
        selectedMode={selectedMode}
        useSlider={useSlider}
      />
    </>
  );
};

export default CategoryContentType;
